export const handleChangeDataHeaderMobile = (name, value) => ({
    type: 'CHANGE_DATA_HEADER_MOBILE', name, value
});
